
import { Outlet } from "react-router-dom";
import { ModalProvider } from "../context/ModalContext";
const MasterLayout = () => {
    return (
        <ModalProvider>
            <Outlet />
        </ModalProvider>
    )
}
export default MasterLayout;